import actionTypes from '../constants/action-types';

const setInputValue = (inputValue, options = {}) => ({
  type: actionTypes.SET_INPUT_VALUE,
  payload: {
    inputValue,
    options,
  },
});

export default setInputValue;
